import Default from '@app/constants';
import { FilterStation, WnnServiceManageTable } from '@app/typings/services/winnonie/station';
import { getRowsPerPage } from '@app/utils/localStorage';
import { get, set } from 'lockr';
import { firstTable } from '../../components/service/form/ManageTable';

const stationTableWNN: string = 'winnonie/station.manageTable';
const filterStations: string = 'winnonie/stations.filters';

export const setManageTableStationsWinnonie = (value: WnnServiceManageTable) => {
  set(stationTableWNN, value);
};
export const getManageTableStationsWinnonie = (): WnnServiceManageTable => {
  return get(stationTableWNN) || firstTable;
};

export const setFilterStationsWinnonie = (value: FilterStation) => {
  set(filterStations, value);
};
export const getFilterStationsWinnonie = (): FilterStation => {
  return get(filterStations) || { filters: Default.filter.winnonie.stations, pages: Default.pages };
};
export const clearFilterStationsWinnonie = () => {
  return set(filterStations, {
    filters: Default.filter.winnonie.stations,
    pages: {
      offset: Default.pages.offset,
      limit: getFilterStationsWinnonie().pages.limit || Number(getRowsPerPage()),
    },
  });
};
